import React from "react"
import { ModalM } from "../components/modal/ModalM"
import { ActivityIndicator, ScrollView } from "react-native"
import { View } from "react-native"
import TitleM from "../components/text/TitleM"
import IconButtonM from "../components/button/IconButtonM"
import { theme } from "../theme/theme"

/**
 * @param {boolean} [scrollable=true] - Scroll the whole modal body. Pass false
 *   when the content owns its own bounded scroll area, so the modal does not
 *   add a second scrollbar next to it and the header stays put.
 * @param {object} [style] - Merged into the modal card's style (its width, an
 *   anchoring to the bottom of the screen).
 */
export const ModalSkeleton = ({
    isVisible,
    onClose,
    title,
    loading,
    children,
    scrollable = true,
    style,
}) => {
    const Body = scrollable ? ScrollView : View
    const bodyProps = scrollable
        ? {
              style: { maxHeight: "100%" },
              contentContainerStyle: {
                  paddingHorizontal: 16,
                  paddingBottom: 16,
              },
          }
        : { style: { paddingHorizontal: 16, paddingBottom: 16 } }

    return (
        <ModalM
            visible={isVisible}
            style={{ maxHeight: "90%", ...style }}
            onDismiss={onClose}
        >
            <Body {...bodyProps}>
                <View
                    style={{
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginTop: 12,
                        marginBottom: 12,
                    }}
                >
                    {/* Bounded so a title long enough to wrap can't take the
                        whole row and push the × past the card, which clips it
                        (`overflow: hidden`) — the modal loses its close button. */}
                    <View style={{ flex: 1, marginRight: 8 }}>
                        <TitleM fontWeight="ExtraBold">{title}</TitleM>
                    </View>
                    <IconButtonM
                        icon="times"
                        size={20}
                        onPress={onClose}
                        iconColor={theme.colors.primary}
                    />
                </View>
                {loading ? (
                    <ActivityIndicator
                        size="small"
                        color={theme.colors.primary}
                    />
                ) : (
                    children
                )}
            </Body>
        </ModalM>
    )
}
